import type { SimilarSearchRequest, SimilarSearchResponse } from './types';
import { createAxiosForRailsApi } from '../common/utils/http';

/**
 * 類似投稿を検索する
 */
export async function searchSimilarTopics(
  request: SimilarSearchRequest
): Promise<SimilarSearchResponse> {
  const client = createAxiosForRailsApi();
  const response = await client.post<{
    results: Array<{
      topic_id: number;
      title: string;
      snippet: string;
      url: string;
      score: number;
      target_age?: string;
      target_gender?: string;
    }>;
  }>('/v2/api/similar_search', { similar_search: { query: request.query } });

  // snake_case から camelCase に変換
  return {
    results: response.data.results.map(r => ({
      topicId: r.topic_id,
      title: r.title,
      snippet: r.snippet,
      url: r.url,
      score: r.score,
      targetAge: r.target_age,
      targetGender: r.target_gender
    }))
  };
}
